<template>
  <v-app>
    <Header />

    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>

    <Footer />
  </v-app>
</template>

<script>
import Footer from "./components/Footer";
import Header from "./components/Header";
console.log('MODE:', process.env.NODE_ENV)
export default {
  name: "App",
  components: {
    Footer,
    Header
  }
};
</script>
